/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2476
 */

var r = require(/* 1434 */"../../../../1436/1176/1434")(Object.keys, Object)
module.exports = r
